import angular from 'angular';

import RegroupementSitesRoute from './_config/regroupement.sites.routes';
import RegroupementSitesConfiguration from './_config/regroupement.sites.config';

import RegroupementSitesComponent from './components/regroupement-sites';

import RegroupementSitesService from './services/regroupement.sites.service';

const moduleName = 'app.massia.gestion.regroupement.sites';

angular
	.module(moduleName, [])
	.config(RegroupementSitesRoute)
	.config(RegroupementSitesConfiguration)
	.component('regroupementSites', RegroupementSitesComponent)
	.service('RegroupementSitesService', RegroupementSitesService);

export default moduleName;
